module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6 left-pane"
  }, [_c('div', {
    staticClass: "col-xs-12 nav-pane"
  }, [_c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/component1"
    }
  }, [_vm._v("Component 1")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/component2"
    }
  }, [_vm._v("Component 2")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/component3"
    }
  }, [_vm._v("Component 3")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 component-pane"
  }, [_c('router-view')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-6 vuex-pane"
  }, [_c('vuex-view')], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-0359a347"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 106
// module chunks = 1